import services from "../services";
import * as types from "./mutation-type";

export const ActionGetModules = async ({ commit }) => {
    const { data } = await services.index();
    if (data.error === false) {
        await commit(types.SET_MODULES, data.data);
        return Promise.resolve(data.data);
    }
    return Promise.reject(data);
};
